import { render, staticRenderFns } from "./DataModeVuetable.vue?vue&type=template&id=740e4800&"
import script from "./DataModeVuetable.vue?vue&type=script&lang=js&"
export * from "./DataModeVuetable.vue?vue&type=script&lang=js&"
import style0 from "./DataModeVuetable.vue?vue&type=style&index=0&id=740e4800&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports